<login *ngIf="!isRegister" [fromExternalLink]="loginFromExternalLink"></login>
<register *ngIf="isRegister"></register>
